//邮箱验证:

export const emailVerification = function (rule, value, callback) {
    let reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
    if (typeof value == 'number') {
        value = value.toString();
    }
    if (value && value.length > 0) {
        if (reg.test(value) == true) {
            callback();
        } else {
            callback(new Error('请填入正确的格式的邮箱'))
        } /*进行验证*/
    } else {
        callback(new Error(' '))
    }
}
//电话或手机号码验证:

export const telPhoneValidate = function (rule, value, callback) {
    if (value) {
        if (value.length == 11 && value.indexOf('-') == -1) {
            if (!(/^1[345678]\d{9}$/.test(value))) {
                callback(new Error('手机号码格式不正确'));
            }
        } else if (value.indexOf('-') != -1) {
            if (!/^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/.test(value)) {
                callback(new Error('手机号码格式不正确'));
            }
        } else {
            callback(new Error('手机号码格式不正确'));
        }
    }
    callback()
}
//账号密码验证:
// 6~16位字符，至少包含三种元素：数字、大写字母、小写字母或特殊字符
export const passwordChange = function (rule, value, callback) {
    let reg = /((^(?=.*[a-z])(?=.*[A-Z])(?=.*\W)[\da-zA-Z\W]{6,16}$)|(^(?=.*\d)(?=.*[A-Z])(?=.*\W)[\da-zA-Z\W]{6,16}$)|(^(?=.*\d)(?=.*[a-z])(?=.*\W)[\da-zA-Z\W]{6,16}$)|(^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[\da-zA-Z\W]{6,16}$))/;
    if (value && value.length > 0) {
        if (reg.test(value) == true) {
            callback();
        } else {
            callback(new Error('请填入正确的格式的账号密码'))
        } /*进行验证*/
    } else {
        callback(new Error('请填入正确的格式的账号密码'))
    }
}

// 身份证格式验证
export const IDVerification = function (rule, value, callback) {
    if (value == "0") {
        let reg = /(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
        if (reg.test(value) == true) {
            callback();
        } else {
            callback(new Error('证件号码格式错误'))
        }
    }
}
// if (value == "0") {


// 个人注册1
export const individualRegistration1 = {
    name: [
        { required: true, message: '请输入个人姓名', trigger: 'blur' }
    ],
    certificateNum: [
        { required: true, message: '请输入证件号码', trigger: 'blur' }
    ],

    address: [
        { required: true, message: '请输入通信地址', trigger: 'blur' }
    ],
    telNo: [
        { required: true, message: '请输入手机号码', trigger: 'blur' },
        { validator: telPhoneValidate, trigger: 'blur' }
    ],
    email: [
        { required: true, message: '请输入电子邮箱', trigger: 'blur', },
        { validator: emailVerification, trigger: 'blur' }
    ],

}

// 个人注册2
export const individualRegistration2 = {
    userName: [
        { required: true, message: '请输入用户账号', trigger: 'blur' }
    ],
    cypher: [
        { required: true, message: '请输入账号密码', trigger: 'blur' },
        { validator: passwordChange, trigger: 'blur' }
    ],
    isPassword: [
        { required: true, message: '请输入确认密码', trigger: 'blur' },
        { validator: passwordChange, trigger: 'blur' }
    ],
}

const validlegalbizLicNum= (rule, value, callback) => {
    let Ancode;//统一社会信用代码的每一个值
    let Ancodevalue;//统一社会信用代码每一个值的权重
    let total = 0;
    let weightedfactors = [1, 3, 9, 27, 19, 26, 16, 17, 20, 29, 25, 13, 8, 24, 10, 30, 28];//加权因子
    //不用I、O、S、V、Z
    let str = '0123456789ABCDEFGHJKLMNPQRTUWXY';
    for (let i = 0; i < value.length - 1; i++) {
        Ancode = value.substring(i, i + 1);
        Ancodevalue = str.indexOf(Ancode);
        total = total + Ancodevalue * weightedfactors[i];
        //权重与加权因子相乘之和
    }
    let logiccheckcode = 31 - total % 31;
    if (logiccheckcode == 31) {
        logiccheckcode = 0;
    }
    let Str = "0,1,2,3,4,5,6,7,8,9,A,B,C,D,E,F,G,H,J,K,L,M,N,P,Q,R,T,U,W,X,Y";
    let Array_Str = Str.split(',');
    logiccheckcode = Array_Str[logiccheckcode];

    let checkcode = value.substring(17, 18);
    if (logiccheckcode != checkcode) {
        return callback(new Error('校验失败，请输入正确的统一社会信用代码！'));;
    }
    return callback();
};
// 法人注册
export const legalPersonRegistration1 = {
    belongInst: [
        { required: true, message: '请输入单位名称', trigger: 'blur' }
    ],
    socialUnifiedCredit: [
            { required: true, message: "请输入统一社会信用代码", trigger: "blur" },
            {
                type: "string",
                max: 18,
                message: "输入有误，统一社会信用代码长度需为18位",
                trigger: "change"
            },
            {
                type: "string",
                pattern: /^([1,5,9][1,2,3,9]|[2,3,4,6,7,8,A,B,C,D,E,G,Y]1)\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/,
                message: "请输入正确的统一社会信用代码",
                trigger: "blur"
            },
            { validator: validlegalbizLicNum, trigger: 'blur' }
    ],
    districtCode: [
        { required: true, message: '请输入所在地区', trigger: 'blur' }
    ],
    address: [
        { required: true, message: '请输入单位地址', trigger: 'blur' }
    ],
    licenseList: [
        { required: true, type: 'array', message: "请选择要上传的文件", trigger: "change" }
    ],
}
export const legalPersonRegistration2 = {
    legalRepresentative: [
        { required: true, message: '请输入法定代表人', trigger: 'blur' }
    ],
    certificateNum: [
        { required: true, message: '请输入证件号', trigger: 'blur' },
    ],
    termStart: [
        { required: true, message: '请输入证件有效期', trigger: 'change' },
    ],
    scanningCopy: [
        { required: true, type: 'array', message: "请选择要上传的文件", trigger: "change" }
    ],
    telNo: [
        { required: true, message: '请输入手机号码', trigger: 'blur' },
        { validator: telPhoneValidate, trigger: 'blur' }
    ],
    email: [
        { required: true, message: '请输入电子邮箱', trigger: 'blur', },
        { validator: emailVerification, trigger: 'blur' }
    ],

}
// 法人注册账号密码
export const legalPersonRegistration3 = {
    userName: [
        { required: true, message: '请输入用户账号', trigger: 'blur' }
    ],
    cypher: [
        { required: true, message: '请输入账号密码', trigger: 'blur' },
        { validator: passwordChange, trigger: 'blur' }
    ],
    isPassword: [
        { required: true, message: '请输入确认密码', trigger: 'blur' },
        { validator: passwordChange, trigger: 'blur' }
    ],
}
// 法人注册增加经办人
export const legalPersonRegistration4 = {
    legalRepresentative: [
        { required: true, message: '请输入法定代表人', trigger: 'blur' }
    ],
    certificateNum: [
        { required: true, message: '请输入证件号', trigger: 'blur' },
    ],
    scanningCopy: [
        { required: true, type: 'array', message: "请选择要上传的文件", trigger: "change" }
    ],
    licenseList: [
        { required: true, type: 'array', message: "请选择要上传的文件", trigger: "change" }
    ],
    telNo: [
        { required: true, message: '请输入手机号码', trigger: 'blur' },
        { validator: telPhoneValidate, trigger: 'blur' }
    ],
    email: [
        { required: true, message: '请输入电子邮箱', trigger: 'blur', },
        { validator: emailVerification, trigger: 'blur' }
    ],
}
//
